export default __webpack_public_path__ + "static/media/mobile.20fa7549.svg";